module.exports = __webpack_public_path__ + "stoptalking.14f2d19b.png";